// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { py, mx } from 'styled-components-spacing';

import { fontLink, fontLinkActive, HeroNavBar } from '@styles/typography';

export const StyledLinkNavigation = styled.a`
  ${py(0)}
  ${({ active }) => (active ? fontLinkActive : fontLink)}
  ${({ heroSection }) => (heroSection && HeroNavBar)}
  font-weight: ${({ active }) => (active ? 600 : 500)};

  transition: all 0.5s ease;

  cursor: pointer;

  ${breakpoint('desktop')`
    font-size: 16px;
    ${py(0)}
    ${mx(3)}
  `}
    ${breakpoint('mobile', 'desktop')`
      font-size: 18px;
      border-bottom: 2px solid lightgrey;
      justify-content: center;
      color: black !important;
      line-height: 35px;
      @media only screen and (max-width: 340px) {
        font-size: 14px;
        line-height: 27px;
      }
  `}
  
  ${breakpoint('largeDesktop')`
    font-size: 18px;
    ${mx(4)}
  `}
`;
